/**
 * Checks if a script exists in the document
 * @param {string} srcPath - The path to the script
 * @returns {boolean} - True if the script exists, false otherwise
 */
export function scriptExists(srcPath) {
  const scripts = document.getElementsByTagName('script');
  let i = scripts.length;
  let flag = false;
  while (i--) {
    if (scripts[i].src === srcPath) {
      flag = true;
      break;
    }
  }
  return flag;
}
